import { render, staticRenderFns } from "./onClick-editor.vue?vue&type=template&id=51ba4326&scoped=true"
import script from "./onClick-editor.vue?vue&type=script&lang=js"
export * from "./onClick-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba4326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ba4326')) {
      api.createRecord('51ba4326', component.options)
    } else {
      api.reload('51ba4326', component.options)
    }
    module.hot.accept("./onClick-editor.vue?vue&type=template&id=51ba4326&scoped=true", function () {
      api.rerender('51ba4326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onClick-editor.vue"
export default component.exports